export const images = [
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(1).jpg?alt=media&token=0e74e859-3028-4c50-8348-e3d9477c70f9",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(1).jpg?alt=media&token=0e74e859-3028-4c50-8348-e3d9477c70f9",
    width: 420,
    height: 174,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(2).jpg?alt=media&token=f7958134-99f5-4dda-b97d-2b858f7d006b",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(2).jpg?alt=media&token=f7958134-99f5-4dda-b97d-2b858f7d006b",
    width: 240,
    height: 212,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(3).jpg?alt=media&token=c75133a0-8dd5-4fd5-a4aa-61aa8ec5fda1",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(3).jpg?alt=media&token=c75133a0-8dd5-4fd5-a4aa-61aa8ec5fda1",
    width: 420,
    height: 212,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(4).jpg?alt=media&token=0eb6e9c9-40b2-4e4f-9805-aa69f96c0342",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(4).jpg?alt=media&token=0eb6e9c9-40b2-4e4f-9805-aa69f96c0342",
    width: 240,
    height: 213,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(5).jpg?alt=media&token=a98bbe82-24bf-4e5b-a051-8605dce36297",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(5).jpg?alt=media&token=a98bbe82-24bf-4e5b-a051-8605dce36297",
    width: 240,
    height: 183,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(6).jpg?alt=media&token=b7266869-cd3c-4076-9b03-0503891825ac",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(6).jpg?alt=media&token=b7266869-cd3c-4076-9b03-0503891825ac",
    width: 240,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(7).jpg?alt=media&token=68c499df-7efd-4a79-95ac-78da497fe078",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(7).jpg?alt=media&token=68c499df-7efd-4a79-95ac-78da497fe078",
    width: 420,
    height: 190,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(8).jpg?alt=media&token=d23d62d1-583f-40b9-9791-bd0700e4aa49",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(8).jpg?alt=media&token=d23d62d1-583f-40b9-9791-bd0700e4aa49",
    width: 420,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(9).jpg?alt=media&token=6fce43d8-f688-472f-925d-77cdf1c79925",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(9).jpg?alt=media&token=6fce43d8-f688-472f-925d-77cdf1c79925",
    width: 320,
    height: 213,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(10).jpg?alt=media&token=ac33fdb9-7a25-40b7-af6f-da135a609e1d",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(10).jpg?alt=media&token=ac33fdb9-7a25-40b7-af6f-da135a609e1d",
    width: 420,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(11).jpg?alt=media&token=7b963fcc-f0ce-4012-8da7-10d35e7fae18",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(11).jpg?alt=media&token=7b963fcc-f0ce-4012-8da7-10d35e7fae18",
    width: 210,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(12).jpg?alt=media&token=8ae452e6-5309-4b90-afc3-ca233434657c",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(12).jpg?alt=media&token=8ae452e6-5309-4b90-afc3-ca233434657c",
    width: 240,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(13).jpg?alt=media&token=cf290c2d-79dd-40c6-b24a-a2028cfbc8b8",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(13).jpg?alt=media&token=cf290c2d-79dd-40c6-b24a-a2028cfbc8b8",
    width: 250,
    height: 213,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(14).jpg?alt=media&token=4a3469f7-9e30-48e5-adf6-7f2d937183cc",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(14).jpg?alt=media&token=4a3469f7-9e30-48e5-adf6-7f2d937183cc",
    width: 240,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(15).jpg?alt=media&token=0838dd1b-0abd-473b-9d4c-a98ea09fa64e",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(15).jpg?alt=media&token=0838dd1b-0abd-473b-9d4c-a98ea09fa64e",
    alt: "Cosmos Flower",
    width: 420,
    height: 213,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(16).jpg?alt=media&token=d39ad6b8-96b2-4e9c-ac96-5b41e9b8654c",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(16).jpg?alt=media&token=d39ad6b8-96b2-4e9c-ac96-5b41e9b8654c",
    width: 420,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(17).jpg?alt=media&token=8a0ac485-dc4d-4290-ab21-24fcd81d5984",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(17).jpg?alt=media&token=8a0ac485-dc4d-4290-ab21-24fcd81d5984",
    width: 240,
    height: 213,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(18).jpg?alt=media&token=d0a4cdef-a966-4e38-a6a1-3e489d14024e",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(18).jpg?alt=media&token=d0a4cdef-a966-4e38-a6a1-3e489d14024e",
    width: 420,
    height: 213,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(19).jpg?alt=media&token=2e745cf8-54d7-4fc2-a599-37e53541e26e",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(19).jpg?alt=media&token=2e745cf8-54d7-4fc2-a599-37e53541e26e",
    width: 240,
    height: 213,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(20).jpg?alt=media&token=9d79c6cf-751c-404d-a628-8a26e92701ae",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(20).jpg?alt=media&token=9d79c6cf-751c-404d-a628-8a26e92701ae",
    width: 420,
    height: 213,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(21).jpg?alt=media&token=b0b5e804-a7cc-4ac1-a6fb-bc0d83c92e82",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(21).jpg?alt=media&token=b0b5e804-a7cc-4ac1-a6fb-bc0d83c92e82",
    width: 400,
    height: 179,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(22).jpg?alt=media&token=27a043b6-b80a-4580-8635-9c9e17021789",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(22).jpg?alt=media&token=27a043b6-b80a-4580-8635-9c9e17021789",
    width: 420,
    height: 215,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(23).jpg?alt=media&token=a39fc020-4f82-4392-bf14-103da467bd65",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(23).jpg?alt=media&token=a39fc020-4f82-4392-bf14-103da467bd65",
    width: 380,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(24).jpg?alt=media&token=c254e146-e18f-4a32-97bd-a9807c86a15d",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(24).jpg?alt=media&token=c254e146-e18f-4a32-97bd-a9807c86a15d",
    width: 420,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(25).jpg?alt=media&token=5a69ad97-57a5-4273-9365-69930484582b",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(25).jpg?alt=media&token=5a69ad97-57a5-4273-9365-69930484582b",
    width: 420,
    height: 220,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(26).jpg?alt=media&token=f7a59ffa-001f-4b84-8f20-e9dcb91b3dad",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(26).jpg?alt=media&token=f7a59ffa-001f-4b84-8f20-e9dcb91b3dad",
    width: 420,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(27).jpg?alt=media&token=a0c75b32-78c3-441e-9af4-09a218533d31",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(27).jpg?alt=media&token=a0c75b32-78c3-441e-9af4-09a218533d31",
    width: 320,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(28).jpg?alt=media&token=1b002371-d55e-4c3b-8e5a-4c20cd8cfc2b",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(28).jpg?alt=media&token=1b002371-d55e-4c3b-8e5a-4c20cd8cfc2b",
    width: 320,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(29).jpg?alt=media&token=7d313fa8-d9ab-4f10-995b-3b3fdf8f549d",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(29).jpg?alt=media&token=7d313fa8-d9ab-4f10-995b-3b3fdf8f549d",
    width: 320,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(30).jpg?alt=media&token=09c8c224-d6e9-4be3-b1bf-5dbd9dc726ea",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(30).jpg?alt=media&token=09c8c224-d6e9-4be3-b1bf-5dbd9dc726ea",
    width: 226,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(31).JPG?alt=media&token=61b29538-531e-4687-b963-714950328301",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(31).JPG?alt=media&token=61b29538-531e-4687-b963-714950328301",
    width: 300,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(32).jpg?alt=media&token=9336ecd0-7182-487d-ba00-43e205e21f6f",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(32).jpg?alt=media&token=9336ecd0-7182-487d-ba00-43e205e21f6f",
    width: 320,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(33).jpg?alt=media&token=1898fea6-b9a6-411d-bb74-cf002fed1315",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(33).jpg?alt=media&token=1898fea6-b9a6-411d-bb74-cf002fed1315",
    width: 320,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(34).jpg?alt=media&token=ac5d9743-a914-4195-ab5c-82079ff1ef01",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(34).jpg?alt=media&token=ac5d9743-a914-4195-ab5c-82079ff1ef01",
    width: 320,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(35).jpg?alt=media&token=51f2f1e7-3d86-4f65-a691-e264a397895b",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(35).jpg?alt=media&token=51f2f1e7-3d86-4f65-a691-e264a397895b",
    width: 320,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(36).jpg?alt=media&token=08221281-af43-40a8-9e5c-34756f56969e",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(36).jpg?alt=media&token=08221281-af43-40a8-9e5c-34756f56969e",
    width: 320,
    height: 320,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(37).jpg?alt=media&token=e60ab2a2-f9ac-4741-86d1-ddd1a4463bec",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(37).jpg?alt=media&token=e60ab2a2-f9ac-4741-86d1-ddd1a4463bec",
    width: 320,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(38).jpg?alt=media&token=25938e82-5edb-4baf-a2db-4f217e58d0ad",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(38).jpg?alt=media&token=25938e82-5edb-4baf-a2db-4f217e58d0ad",
    width: 320,
    height: 180,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(39).jpg?alt=media&token=48834d6f-dd39-4237-b77a-64a2e7dff2b4",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(39).jpg?alt=media&token=48834d6f-dd39-4237-b77a-64a2e7dff2b4",
    width: 320,
    height: 180,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(40).jpg?alt=media&token=95c2aad4-bb5d-4312-bbc5-bd28f00e7f4a",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(40).jpg?alt=media&token=95c2aad4-bb5d-4312-bbc5-bd28f00e7f4a",
    width: 320,
    height: 180,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(41).jpg?alt=media&token=b30948c4-b0ea-4eb8-b173-2b34fb98f127",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(41).jpg?alt=media&token=b30948c4-b0ea-4eb8-b173-2b34fb98f127",
    width: 320,
    height: 180,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(42).jpg?alt=media&token=7b2a13b5-f731-40cc-a3cf-5d14b5b2a054",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(42).jpg?alt=media&token=7b2a13b5-f731-40cc-a3cf-5d14b5b2a054",
    width: 320,
    height: 180,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(43).jpg?alt=media&token=61b2c299-263a-4d90-b81e-9845f7a69f9a",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(43).jpg?alt=media&token=61b2c299-263a-4d90-b81e-9845f7a69f9a",
    width: 420,
    height: 180,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(44).jpg?alt=media&token=f3f2ca86-0d1a-43ea-add6-c84b77f65af1",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(44).jpg?alt=media&token=f3f2ca86-0d1a-43ea-add6-c84b77f65af1",
    width: 420,
    height: 200,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(45).JPG?alt=media&token=d56e6357-d969-4ab5-bbd2-82c72a865f3e",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(45).JPG?alt=media&token=d56e6357-d969-4ab5-bbd2-82c72a865f3e",
    width: 320,
    height: 180,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(46).jpg?alt=media&token=1ca14077-0677-4154-870d-65377bb3938d",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(46).jpg?alt=media&token=1ca14077-0677-4154-870d-65377bb3938d",
    width: 320,
    height: 180,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(47).jpg?alt=media&token=5fba791b-34e9-47a2-8146-05c38323085c",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(47).jpg?alt=media&token=5fba791b-34e9-47a2-8146-05c38323085c",
    width: 320,
    height: 180,
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(48).jpg?alt=media&token=a9810a02-9950-4860-a8c1-e85d6521bfc1",
    original:
      "https://firebasestorage.googleapis.com/v0/b/alexgeekresume.appspot.com/o/Gallery%2FAlexGeek%20(48).jpg?alt=media&token=a9810a02-9950-4860-a8c1-e85d6521bfc1",
    width: 420,
    height: 200,
  },
];
